const overrideStage = true
const stageBundleId = 'cb100523153034'
const samplesVersion = '1.0.5'

const codeSamplesUrl =
  typeof window !== 'undefined' &&
  (window.location.host.includes('developer.paypal.com') || overrideStage)
    ? `https://www.paypalobjects.com/ib-codesample/${samplesVersion}`
    : `https://cdn-${stageBundleId}.static.engineering.dev.paypalinc.com/ib-codesample/${samplesVersion}`

const zippedSamplesUrl =
  typeof window !== 'undefined' &&
  (window.location.host.includes('developer.paypal.com') || overrideStage)
    ? `https://paypalobjects.com/ppdevdocs/static/zipped_samples`
    : `https://cdn-${stageBundleId}.static.engineering.dev.paypalinc.com/timdev/ib_codesamples/zipped_samples`

module.exports = {
  codeSamplesUrl,
  zippedSamplesUrl,
}
